import React from 'react';
import { marked } from 'marked';
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {

  // 确保文本是 Markdown 格式
  const ensureMarkdownFormat = (text: string): string => {
    // 如果文本中没有 Markdown 标记，可以添加一些基本格式
    if (!text.includes('```') && !text.includes('#') && !text.includes('*')) {
      // 这里可以添加一些基本的 Markdown 格式化逻辑
      return text;
    }
    return text;
  };

  // 渲染 Markdown 内容
  const renderMarkdown = (text: string): string => {
    try {
      // 直接在调用 marked 时传入选项
      const html = marked(text, {
        breaks: true,
        gfm: true,
        highlight: function(code: string, lang: string): string {
          if (lang && hljs.getLanguage(lang)) {
            try {
              return hljs.highlight(code, { language: lang }).value;
            } catch (err) {
              console.error('Highlight error:', err);
            }
          }
          return hljs.highlightAuto(code).value;
        }
      }) as string;
      
      // 添加代码块复制按钮
      return html.replace(
        /<pre><code class="language-([\w-]+)">((([\s\S])*?))<\/code><\/pre>/g, 
        (match: string, language: string, code: string) => {
          return `
            <div class="code-block-wrapper">
              <div class="code-block-header">
                <span>${language}</span>
                <button 
                  class="copy-button"
                  onclick="navigator.clipboard.writeText(decodeURIComponent('${encodeURIComponent(code)}'))"
                >
                  复制
                </button>
              </div>
              <pre><code class="language-${language}">${code}</code></pre>
            </div>
          `;
        }
      );
    } catch (error) {
      console.error('Markdown渲染错误:', error);
      return text;
    }
  };

  // 将渲染结果设置为 HTML
  const formattedContent = ensureMarkdownFormat(content);
  const renderedHTML = renderMarkdown(formattedContent);

  return (
    <div 
      className="markdown-content"
      dangerouslySetInnerHTML={{ __html: renderedHTML }}
    />
  );
};

export default MarkdownRenderer;
